//import TextBookWriteArea from "@/pages/comp/book_order/textbook/common/write";
import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import TextBookSortManagePopup from "@/pages/comp/book_order/textbook_sort/popup/manage_list";
import TextBookSortManageSort from "@/pages/comp/book_order/textbook_sort/common/manage_sort";
import TextBookAddWordPopup from "@/pages/comp/book_order/textbook/popup/add_word";
import TextBookManageWordPopup from "@/pages/comp/book_order/textbook/popup/manage_word";
import TextBookManageWordCoolPopup from "@/pages/comp/book_order/textbook/popup/manage_word_cool";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import LoadingComponent from "@/pcomponents/common/content/loading";
import TabArea from "./area/tab_area";
import WriteArea from "./area/write";
import SectionStudyArea from "./area/section_study";

const TextBookWriteArea = forwardRef((props: any, ref) => {
  let myProps = {
    row_data: {},
    is_update: false,
    refresh_list: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const pageData = {
    "write_btn_text": "등록",
    "confirm_msg": "등록 하시겠습니까?",
  };
  const [active_tab, set_active_tab] = useState("all");
  const [is_update, set_is_update] = useState(myProps.is_update);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장중..",
  });
  if (is_update) {
    pageData["write_btn_text"] = "저장";
    pageData["confirm_msg"] = "저장 하시겠습니까?";
  }
  const init_data = {
    a_seq: "",
    a_title: "",
    a_use_sort: "study",//study:교재,procedure:절차,coolen:쿨잉,word_inside:내신영어,study_word:단어학습
    a_is_able_order: "1",
    a_is_book: "1",
    a_is_online: "1",
    a_subject: "",
    a_category_seq: "",
    a_sort1_seq: "",
    a_sort2_seq: "",
    a_sort3_seq: "",
    a_answer_link_url: "",
    a_book_pdf_url: "",
    a_book_total_page: 0,
    a_is_progress: "",
    a_is_mapping: "",
    a_par_id: "",
    a_par_seq: "",
    section_arr: [],
    study_arr: [],
    use_stu_arr: [],
    product_info: {},
    product_info_user: {},
    ...myProps.init_data
  };
  const [rowData, setRowData] = useState<any>({
    ...init_data
  });
  const [category_arr, set_category_arr] = useState<any>([]);
  const [sort1_arr, set_sort1_arr] = useState<any>([]);
  const [sort2_arr, set_sort2_arr] = useState<any>([]);
  const [sort3_arr, set_sort3_arr] = useState<any>([]);

  useEffect(() => {

  }, []);

  const setInitData = (inOptObj: any) => {
    if (inOptObj == undefined) {
      inOptObj = {};
    }
    let optObj = {
      row_data: {},
      is_update: false,
      ...inOptObj
    };

    let tmp_section_arr = [];
    let tmp_study_arr = [];
    if (optObj.row_data.section_arr) {
      tmp_section_arr = optObj.row_data.section_arr;
    }
    if (optObj.row_data.study_arr) {
      tmp_study_arr = optObj.row_data.study_arr;
    }
    setRowData({
      ...init_data,
      ...optObj.row_data,
      ...{
        section_arr: [...tmp_section_arr],
        study_arr: [...tmp_study_arr],
      }
    });
    set_is_update(optObj.is_update);
    if (optObj.is_update && optObj.row_data.a_seq) {
      get_info_by_ajax({ a_seq: optObj.row_data.a_seq });
    }
  };
  const refresh_manage_sort = (inData: any) => {
    let opt_obj = {
      row_data: {},
      ...inData
    };
    if (!strFunc.is_empty(opt_obj.row_data.a_subject)) {
      get_textbook_sort_by_ajax({ s_type: "category", s_par_id: "subject", s_par_seq: opt_obj.row_data.a_subject });
    }
    if (!strFunc.is_empty(opt_obj.row_data.a_category_seq)) {
      get_textbook_sort_by_ajax({ s_type: "sort1", s_par_id: "mtextbook_sort", s_par_seq: opt_obj.row_data.a_category_seq });
    }
    if (!strFunc.is_empty(opt_obj.row_data.a_sort1_seq)) {
      get_textbook_sort_by_ajax({ s_type: "sort2", s_par_id: "mtextbook_sort", s_par_seq: opt_obj.row_data.a_sort1_seq });
    }
    if (!strFunc.is_empty(opt_obj.row_data.a_sort2_seq)) {
      get_textbook_sort_by_ajax({ s_type: "sort3", s_par_id: "mtextbook_sort", s_par_seq: opt_obj.row_data.a_sort2_seq });
    }

  };

  const default_popup_data = {
    isOpen: false,
    sort: "manage_textbook_sort",//view
    listOpt: {},
    g_par_id: "",
    g_par_seq: "",
    title: "팝업",
    width: "100%",
    height: "90%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    setRowData, set_is_update, setInitData
  }));

  const get_textbook_sort_by_ajax = (inData: any) => {
    let opt_obj = {
      s_type: "sort1",
      s_par_id: "mtextbook_sort",
      s_par_seq: "",
      ...inData
    };

    let formJsonData = {
      s_type: opt_obj.s_type,
      s_par_id: opt_obj.s_par_id,
      s_par_seq: opt_obj.s_par_seq,
      order_id: "a_order_num",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/sort/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort3") {
            set_sort3_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "category") {
            set_category_arr(response.data["data"]["info_arr"]);
          }
        }
      });
  };

  const get_info_by_ajax = (inData: any) => {
    let opt_obj = {
      a_seq: rowData.a_seq,
      ...inData
    };

    if (strFunc.is_empty(opt_obj.a_seq)) {
      return false;
    }
    let formJsonData = {
      s_pri_arr: [opt_obj.a_seq],
      s_addon_section: "1",
      s_addon_study: "1",
      s_addon_study_word: "1",
      s_addon_product: "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length == 0) {
            alert("데이터가 존재하지 않습니다.");
            return false;
          }
          let change_row_data = response.data["data"]["info_arr"][0];

          setRowData({
            ...rowData,
            ...change_row_data
          });
          refresh_manage_sort({ row_data: change_row_data });
        } else {
          alert(response.data["msg"]);
        }
        setTimeout(() => {
          set_loading_data({
            is_display: false,
            text: "완료.",
          });
        }, 500);
      });
  };

  const goWrite = () => {
    if (rowData.a_title == "") {
      alert("제목 입력이 필요합니다.");
      return false;
    }
    let wRowData = { ...rowData };

    let formJsonData = {
      "data_arr": [wRowData],
      "is_default_val": "1",
      "is_update": "",
      "is_after_write_study_detail": "1",
      "is_after_write_product": "1",
    };
    if (is_update) {
      formJsonData["is_default_val"] = "";
      formJsonData["is_update"] = "1";
    }
    set_loading_data({
      is_display: true,
      text: "저장중..",
    });

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/write', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "저장되었습니다.",
          });
          if (response.data["data"]) {
            let w_select_seq = response.data["data"][0].a_seq;
            get_info_by_ajax({ a_seq: w_select_seq });
            myProps.refresh_list({ select_seq: w_select_seq });
          }
        } else {
          alert(response.data["msg"]);
        }
        setTimeout(() => {
          set_loading_data({
            is_display: false,
            text: "완료.",
          });
        }, 500);
      });
  };

  const open_manage_textbook_sort_popup = (inData: any) => {
    let opt_obj = {
      s_type: "sort1",
      s_par_id: "mtextbook_sort",
      s_par_seq: "",
      ...inData
    };

    // if(opt_obj.s_type!="sort1"){
    //   if(strFunc.is_empty(opt_obj.s_par_seq)){
    //     alert("분류가 선택되지 않았습니다.");
    //     return false;
    //   }
    // }

    let popup_sort = "manage_textbook_sort2";
    if (opt_obj.s_type == "category") {
      popup_sort = "manage_textbook_sort";
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: popup_sort,
      listOpt: {
        s_type: opt_obj.s_type,
        s_par_id: opt_obj.s_par_id,
        s_par_seq: opt_obj.s_par_seq,
      },
      title: "교재분류 관리",
    });
  };

  const open_add_word_popup = (inData: any) => {
    let opt_obj = {
      g_par_id: "",
      g_par_seq: "",
      ...inData
    };

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      alert("분류가 선택되지 않았습니다.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.g_par_seq)) {
      alert("분류키가 선택되지 않았습니다.");
      return false;
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "add_word",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      title: "단어 추가",
      width: "80%",
    });
  };

  const open_manage_word_popup = (inData: any) => {
    let opt_obj = {
      sort: "manage_word",//manage_word_cool
      g_par_id: "",
      g_par_seq: "",
      ...inData
    };

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      alert("분류가 선택되지 않았습니다.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.g_par_seq)) {
      alert("분류키가 선택되지 않았습니다.");
      return false;
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: opt_obj.sort,
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      title: "단어 관리",
      width: "80%",
    });
  };

  return (
    <div>
      <div>
        <TabArea
          is_update={is_update}
          active_tab={active_tab}
          onChangeTab={(tab_id: string) => {
            set_active_tab(tab_id);
          }}
        ></TabArea>
        {(active_tab == "all") && (
          <WriteArea
            rowData={rowData}
            setRowData={setRowData}
            is_update={is_update}
            get_textbook_sort_by_ajax={get_textbook_sort_by_ajax}
            sort1_arr={sort1_arr}
            sort2_arr={sort2_arr}
            sort3_arr={sort3_arr}
            category_arr={category_arr}
            set_category_arr={set_category_arr}
            set_sort1_arr={set_sort1_arr}
            set_sort2_arr={set_sort2_arr}
            set_sort3_arr={set_sort3_arr}
            open_manage_textbook_sort_popup={open_manage_textbook_sort_popup}
          ></WriteArea>
        )}
        <div className="btn-box-center mt-2">
          <button className="btn btn-line-gray" onClick={goWrite}>{pageData["write_btn_text"]}</button>
        </div>
        <div className='mt-2'>
          {(active_tab == "section_study" || active_tab == "all") && (
            <SectionStudyArea
              section_arr={(rowData.section_arr) ? rowData.section_arr : []}
              study_arr={(rowData.study_arr) ? rowData.study_arr : []}
              set_section_arr={(inData: any) => {
                setRowData({
                  ...rowData,
                  ...{
                    section_arr: [...inData]
                  }
                });
                //set_refresh(!refresh);
              }}
              set_study_arr={(study_arr: any) => {
                setRowData({
                  ...rowData,
                  ...{
                    study_arr: [...study_arr]
                  }
                });
                //set_refresh(!refresh);
              }}
              rowData={rowData}
              setRowData={setRowData}
              open_add_word_popup={open_add_word_popup}
              open_manage_word_popup={open_manage_word_popup}
            ></SectionStudyArea>
          )}
        </div>

        {popupData.isOpen &&
          <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
            width={popupData.width} height={popupData.height} >
            {popupData.sort === "manage_textbook_sort" &&
              <TextBookSortManagePopup
                listOpt={popupData.listOpt}
                callbackData={(inData: any) => { }}
                refreshData={(inData: any) => { refresh_manage_sort({ row_data: rowData }); }}
                closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookSortManagePopup>
            }
            {popupData.sort === "manage_textbook_sort2" &&
              <TextBookSortManageSort
                callbackData={(inData: any) => { }}
                refreshData={(inData: any) => { refresh_manage_sort({ row_data: rowData }); }}
                closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookSortManageSort>
            }
            {popupData.sort === "add_word" &&
              <TextBookAddWordPopup
                g_par_id={popupData.g_par_id}
                g_par_seq={popupData.g_par_seq}
                callbackData={(inData: any) => { }}
                refreshData={(inData: any) => { get_info_by_ajax({}); }}
                closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookAddWordPopup>
            }
            {popupData.sort === "manage_word" &&
              <TextBookManageWordPopup
                g_par_id={popupData.g_par_id}
                g_par_seq={popupData.g_par_seq}
                callbackData={(inData: any) => { }}
                refreshData={(inData: any) => { get_info_by_ajax({}); }}
                closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookManageWordPopup>
            }
            {popupData.sort === "manage_word_cool" &&
              <TextBookManageWordCoolPopup
                g_par_id={popupData.g_par_id}
                g_par_seq={popupData.g_par_seq}
                callbackData={(inData: any) => { }}
                refreshData={(inData: any) => { get_info_by_ajax({}); }}
                closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookManageWordCoolPopup>
            }
          </LayerPopup>
        }
        <LoadingComponent
          is_display={loading_data.is_display}
          text={loading_data.text}
        ></LoadingComponent>
      </div>
    </div>
  );
});
export default TextBookWriteArea;